import { ref, watch, computed } from '@vue/composition-api'
import store from '@/store'
import { stringify,parse } from 'flatted';
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
export default function useNavigationList() {
    const isGroupFormSidebarActive = ref(false);
    const isNavigationFormSidebarActive = ref(false);
    const groups = ref([]);
    const toast = useToast();
    const groupData = ref({});
    const navigationData = ref({});
    const getLocalSite = JSON.parse(localStorage.getItem('site'))
    const updateGroup = (group)=>{
        isGroupFormSidebarActive.value = true;
        groupData.value = group;
    }
    const addGroup = ()=>{
        isGroupFormSidebarActive.value = true;
        groupData.value = {}
    }
    const updateNav = (nav)=>{
        isNavigationFormSidebarActive.value = true;
        const data = parse(stringify(nav));
        let formData = new FormData();
        formData.append('nav', data);
        // console.log("anve ",formData)
        

        navigationData.value = data;
    }
    const addNav = (group_id)=>{
        isNavigationFormSidebarActive.value = true;
        navigationData.value = {
            group_id:group_id
        }
    }
    const refetchData = ()=>{
        store
        .dispatch('app-navigation/fetchData', {
          sites_id: getLocalSite.id
        })
        .then(response => {
            
            const  data  = response.data.data
            groups.value = data;
            // console.log('groups',groups.value);
            //const total = response.data.total?response.data.total:cats.length;
            //callback(cats)
            // for (let key in groups.value[0].navigations)  {
            //   console.log(key, groups.value[0].navigations[key])
            // } 
    
        })
        .catch((error) => {
            toast({
            component: ToastificationContent,
            props: {
                title: "Error fetching Group' list",
                icon: 'AlertTriangleIcon',
                variant: 'danger',
            },
            })
        })
            
    }
    refetchData();
    
const undateOrdering = async (key, type) => {
  const keyJson = stringify(key);
  const types = stringify(type);

  let formData = new FormData();
  formData.append('key', keyJson);

  let navs = keyJson;
  formData.append("types", types);
  let data = {
    formData: formData,
    navs: navs,
  };

  try {
    // Wait for the store.dispatch to complete
    await store.dispatch('app-navigation/updateOrdering', data);
    // Now call refetchData
    refetchData();
  } catch (error) {
    console.error('Error updating ordering:', error);
  }
}


    const deleteData = (id) => {
        //fetchDeleteProperty
        store.dispatch('app-navigation/deleteData',id).then(response=>{
          toast({
            component: ToastificationContent,
            props: {
              title: "Delete Success",
              icon: 'AlertTriangleIcon',
              variant: 'success',
            },
          })
          refetchData();
        }).catch(()=>{
          toast({
            component: ToastificationContent,
            props: {
              title: "Error Delete Navigation",
              icon: 'AlertTriangleIcon',
              variant: 'danger',
            },
          })
    
        })
        //console.log('id', id);
        
      }
      const deleteGroupData = (id) => {
        //fetchDeleteProperty
        store.dispatch('app-navigation/deleteGroupData',id).then(response=>{
          toast({
            component: ToastificationContent,
            props: {
              title: "Delete Success",
              icon: 'AlertTriangleIcon',
              variant: 'success',
            },
          })
          refetchData();
        }).catch(()=>{
          toast({
            component: ToastificationContent,
            props: {
              title: "Error Delete Group Navigation",
              icon: 'AlertTriangleIcon',
              variant: 'danger',
            },
          })
    
        })
        //console.log('id', id);
        
      }
      return {
        groups,
        groupData,
        isGroupFormSidebarActive,
        isNavigationFormSidebarActive,
        undateOrdering,
        updateGroup,
        addGroup,
        refetchData,
        addNav,
        updateNav,
        navigationData,
        deleteData,
        deleteGroupData,
      }
    
}